import { FV } from './share';
import { Form, Radio } from 'antd';
import MaxDiscount from './MaxDiscount';
import { VoucherConfig } from './VoucherConfig';
import DiscountType from './DiscountType';
import DiscountValue from './DiscountValue';
import MultiPackThreshold from './MultiPackThreshold';
import { useFormikContext } from 'formik';
import { useTranslate } from '@tolgee/react';
import { useMemo } from 'react';

function PromotionType({
  disabled = false,
  isEdit = false,
}: {
  disabled?: boolean;
  isEdit?: boolean;
}) {
  const { t } = useTranslate();

  const { initialValues, values, setValues } = useFormikContext<FV>();

  const { activityType, promotionType, activityVoucherType } = values;

  const options = [
    { value: 'NO_PROMOTION', label: t('无优惠') },
    { value: 'DISCOUNT', label: t('限时折扣') },
    {
      value: 'VOUCHER',
      label: activityType === 'LIVE_STREAMING_ACTIVITY' ? t('直播间专属优惠券') : t('gift_voucher'),
    },
    { value: 'MULTI_PACK_DISCOUNT', label: t('multi_items_discount') },
  ] as const;

  const label =
    activityType === 'NEW_PRODUCT_ONSALE_ACTIVITY'
      ? t('新品优惠')
      : activityType === 'CLEARANCE_SALE_ACTIVITY'
      ? t('促销优惠')
      : activityType === 'LIVE_STREAMING_ACTIVITY'
      ? t('直播优惠')
      : activityType === 'RECOMMEND_HOT_PRODUCT_ACTIVITY'
      ? t('爆款商品优惠')
      : '';

  const type = (
    <Form.Item label={label}>
      <div>
        {options.map(({ value, label }) => {
          return (
            <Radio
              disabled={disabled}
              checked={value === promotionType}
              onChange={({ target: { checked } }) =>
                checked &&
                setValues({
                  ...values,
                  promotionType: value,
                  maxDiscount: initialValues.maxDiscount,
                  discountType: initialValues.discountType,
                  discountValue: initialValues.discountValue,
                  voucherMinOrderAmount: initialValues.voucherMinOrderAmount,
                  multiPackThreshold: initialValues.multiPackThreshold,
                })
              }
            >
              {label}
            </Radio>
          );
        })}
      </div>
    </Form.Item>
  );

  const extra = useMemo(() => {
    if (promotionType === 'DISCOUNT') {
      return <MaxDiscount disabled={disabled} />;
    }

    const isSendVoucher = activityVoucherType === 'SEND_VOUCHER_CARD';
    if (promotionType === 'VOUCHER') {
      return [
        // [直播间专属优惠券] 不支持选择发送优惠券卡片
        activityType !== 'LIVE_STREAMING_ACTIVITY' && (
          <VoucherConfig disabled={disabled} isEdit={isEdit} />
        ),
        !isSendVoucher && <DiscountType disabled={disabled} />,
        !isSendVoucher && <DiscountValue disabled={disabled} />,
      ];
    }
    if (promotionType === 'MULTI_PACK_DISCOUNT') {
      return [
        <MultiPackThreshold disabled={disabled} />,
        !isSendVoucher && <DiscountType disabled={disabled} />,
        !isSendVoucher && <DiscountValue disabled={disabled} />,
      ];
    }
    return null;
  }, [activityType, activityVoucherType, disabled, promotionType, isEdit]);

  return (
    <>
      {type}
      {extra}
    </>
  );
}

export default PromotionType;
